import {
  ASYNC_TEAM_FETCH_STANDINGS_REQUEST,
  ASYNC_TEAM_FETCH_STANDINGS_SUCCESS,
  ASYNC_TEAM_FETCH_STANDINGS_ERROR,
} from './types';


const initialState = {
  isLoading: false,
  // check for cors
  isAuthorized: true,
  client: {
    standingsCompetitions: []
  },
  standingsData: {
    away1X: {},
    away2X: {},
    away11: {},
    away12: {},
    away21: {},
    away22: {},
    awayX1: {},
    awayX2: {},
    awayXX: {},
    goals01: {},
    goals02: {},
    goals3: {},
    goals7: {},
    goals23: {},
    goals46: {},
    halves: {},
    home1X: {},
    home2X: {},
    home11: {},
    home12: {},
    home21: {},
    home22: {},
    homeX1: {},
    homeX2: {},
    homeXX: {},
    leagueStats: {},
    mostDraws: {},
    mostDrawsStreak: {},
    mostGoalGoal: {},
    mostLoses: {},
    mostLossStreak: {},
    mostNoGoal: {},
    mostOver25: {},
    mostUnder25: {},
    mostWins: {},
    mostWinsStreak: {},
    nextMatches: {},
    noLossStreak: {},
    noWinStreak: {},
    previousMatches: {},
    redCards: {},
    scorers: {},
    standings: {},
    teamForm: {},
    teamTotalStats: {},
    yellowCards: {},
  },
  error: '',
};

function flatenArray(arrayOfData) {
  const flattenData = {};

  arrayOfData.forEach(d => {
    d.name === 'standingsCompetitions' ? flattenData[d.name] = JSON.parse(d.option_value) : flattenData[d.name] = d.option_value;
  });

  return flattenData;
}

export default function standingsReducer(state = initialState, action) {
  switch (action.type) {
  case ASYNC_TEAM_FETCH_STANDINGS_REQUEST:
    return {
      ...state,
      isLoading: true
    };
  case ASYNC_TEAM_FETCH_STANDINGS_SUCCESS: {
    const { data, client } = action.data;

    return {
      ...state,
      standingsData: data,
      client: {
        ...client,
        ...flatenArray(client.options)
      },
      isAuthorized: true,
      isLoading: false
    };
  }
  case ASYNC_TEAM_FETCH_STANDINGS_ERROR: {
    const { error } = action;
    let isAuthorized = true;

    if (error.response && error.response.status === 401) {
      isAuthorized = false;
    }

    return { 
      ...state,
      isLoading: false,
      isAuthorized,
      error
    };
  }

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/screens/standingsScreen/state/standingsReducer.js